import { EditorAdapter } from "@cuntas-mitool/ui";

/**
 * Web implementation of the editor seam. There is no host document, so
 * "insert" copies to the clipboard (WebTool layers its own toast via the
 * SearchAndInsert onAction override).
 */
export const webEditorAdapter: EditorAdapter = {
	host: "web",
	async insertText(text: string): Promise<void> {
		await navigator.clipboard.writeText(text);
	},
};
